import React from "react";
import { Link } from "react-router-dom";
import { CustomComponentProps } from "utils/types/general.types";

export type Props = CustomComponentProps & {
    content: string;
};

const HashtagString: React.FC<Props> = ({ content, className, style }) => {
    // Regular expression to find words starting with hashtags or mentions
    const mentionRegex = /@(\w+)/g;
    const hashtagRegex = /#(\w+)/g;

    // Function to replace mentions and hashtags with anchor tags
    const renderContent = (text: string) => {
        return text
            .split(" ")
            .map((word, index) => {
                if (word.match(mentionRegex)) {
                    // Extract the mention without the @
                    const mention = word.slice(1);
                    // Replace the mention with an anchor tag containing the link
                    return (
                        <Link
                            key={index}
                            to={`/profile/${mention}`}
                            // href={`#`}
                            className="z-2 relative"
                        >
                            {" "}
                            {word}
                        </Link>
                    );
                } else if (word.match(hashtagRegex)) {
                    const hashtag = word.slice(1);
                    return (
                        <Link
                            key={index}
                            to={`/hashtag/${hashtag}`}
                            // href={`#`}
                            className="z-2 relative"
                        >
                            {" "}
                            {word}
                        </Link>
                    );
                } else {
                    return (
                        <span
                            className="z-2 relative"
                            key={index}
                        >{` ${word}`}</span>
                    );
                }
            })
            .flat();
    };

    return (
        <div className={`${className}`} style={style}>
            {/* Render content with mentions and hashtags replaced with links */}
            {renderContent(content)}
        </div>
    );
};

export default HashtagString;
